export class DebouncedFunction {
    /**
     * Returns a debounced version of the provided function.
     * The provided function will only be called after the provided delay has passed since the last call.
     * @param fn The function to debounce
     * @param delay The debounce delay in milliseconds
     * @returns A debounced version of the provided function
     */
    public static create<T extends (...args: any[]) => any>(fn: T, delay: number): T {
        let timeoutId: number;
        return function(this: any, ...args: Parameters<T>) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = window.setTimeout(() => {
                fn.apply(this, args)
            }, delay);
        } as T;
    }
}
